import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget';
import InsertComparisonCommand from './comparison-command';
export default class ComparisonEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertComparison', new InsertComparisonCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('comparison', {
            isObject: true,
            allowWhere: '$block',
        });
        schema.register('comparisonCorrect', {
            isLimit: true,
            allowIn: 'comparison',
            allowContentOf: '$root',
        });
        schema.register('comparisonIncorrect', {
            isLimit: true,
            allowIn: 'comparison',
            allowContentOf: '$root',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for('upcast').elementToElement({
            model: 'comparison',
            view: 'x-comparison',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'comparison',
            view: 'x-comparison',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'comparison',
            view: (modelElement, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class: 'comparison',
                });
                return toWidget(div, writer, { label: "Do-don't widget" });
            },
        });
        conversion.for('upcast').elementToElement({
            model: 'comparisonCorrect',
            view: 'x-comparison-correct',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'comparisonCorrect',
            view: 'x-comparison-correct',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'comparisonCorrect',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'comparison__correct',
                });
                return toWidgetEditable(div, writer);
            },
        });
        conversion.for('upcast').elementToElement({
            model: 'comparisonIncorrect',
            view: 'x-comparison-incorrect',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'comparisonIncorrect',
            view: 'x-comparison-incorrect',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'comparisonIncorrect',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'comparison__incorrect',
                });
                return toWidgetEditable(div, writer);
            },
        });
    }
}
